// @flow
import UpdateServiceNoShowModalContainer from './UpdateServiceNoShowModalContainer';

export default UpdateServiceNoShowModalContainer;
